import React, { useEffect, useState, useMemo } from 'react';
import { format } from 'date-fns';
import $ from 'jquery';
import * as R from "ramda";

import Emptylustration from '../../../assets/images/svg/057-contract-1.svg';
import { URLParams } from '../../../constants/utils/urlParams';

import { AuditTableFilter } from './filter';
import { AuditTableNav } from './nav';
import { AuditTableRow } from './row';
import { AuditTableLoadMore } from './loadmore';
import { LoadingState } from '../../../_common/loadingState';
import * as Loadings from '../../../constants/loadings/funecap/activityLog';



export const AuditTable = ({ activityLogReducer, routerQuery }) => {
    
    const itemsToDisplay = useMemo(() => {
        let temp = [...activityLogReducer.items];
        if (!R.isNil(routerQuery.userId)) {
            temp = temp.filter(u => u.userId.toString() === routerQuery.userId);
        }
        if (!R.isNil(routerQuery.operatorId)) {
            temp = temp.filter(u => u.operatorId.toString() === routerQuery.operatorId);
        }
        if (!R.isNil(routerQuery.description)) {
            temp = temp.filter(u => u.description.toString() === routerQuery.description);
        }
        // if (!R.isNil(QUERIES.fromDate)) {
        //     temp = temp.filter(u => format(u.date, 'yyyy-MM-dd') === QUERIES.fromDate);
        // }
        // if (!R.isNil(QUERIES.toDate)) {
        //     temp = temp.filter(u => format(u.date, 'yyyy-MM-dd') === QUERIES.toDate);
        // }

        let sortFieldName = "date"
        if(!R.isNil(routerQuery.sortBy)){
            sortFieldName = routerQuery.sortBy === "operatorId" ? "operatorName" : routerQuery.sortBy === "userId" ? "userName" : routerQuery.sortBy;
        }
        if (routerQuery.sortDesc === 'true') {
            temp = R.sortWith([R.descend(R.prop(sortFieldName))])(temp);
        } else{
            temp = R.sortWith([R.ascend(R.prop(sortFieldName))])(temp);
        }
        return temp;
        // eslint-disable-next-line 
    }, [location.search, routerQuery, activityLogReducer.items]);
    return (
        <div className="view-calc pt-sm mb-auto pb-sm">
            <div className="container-fluid">
                <AuditTableFilter routerQuery={routerQuery} activityLogReducer={activityLogReducer} />
            </div>
                {   activityLogReducer.isLoading.includes(Loadings.FETCHING_ACTIVITYLOG) ?
                    <LoadingState />
                    :
                    R.isEmpty(itemsToDisplay) || R.isNil(itemsToDisplay) ?
                        <section className="block fs-3 text-center m-auto py-4">
                            <img className="img-fluid img-contain container-paper mx-auto  mt-auto mb-4" src={Emptylustration} alt="Assist@" />
                            <div className="block text-center container-thin mx-auto mb-auto">
                                <h1 className="font-weight-bolder ls-n2 lh-1">Il n'y a pas d'entrées d'audit.</h1>
                            </div>
                        </section>
                        :
                        <div className="auto-view h-100 mb-auto">
                            <div className="container-fluid">
                                <section className="flex-column gap-xs">
                                    <AuditTableNav activityLogReducer={activityLogReducer} routerQuery={routerQuery} />
                                    {
                                        itemsToDisplay.map((activityLog, index) => (
                                            <AuditTableRow activityLog={activityLog} key={index} />
                                        ))
                                    }
                                    {
                                        R.isNil(activityLogReducer.continuationToken) ?
                                            ''
                                        :
                                            <AuditTableLoadMore continuationToken={activityLogReducer.continuationToken}/>
                                    }

                                    
                                </section>
                            </div>
                        </div>
                        
                }
        </div>
    );
};